import * as ko from "knockout";
import * as $ from "jquery";
import "jquery_drop";
var bindingName = "drop";
var _defaults = function () {
    this.handler = undefined;
    this.start = undefined;
    this.end = undefined;
    this.options = undefined;
    this.enabled = ko.observable(true);
};
ko.bindingHandlers[bindingName] = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var config = ko.createBindingConfig(valueAccessor(), new _defaults());
        if (ko.unwrap(config.enabled) == true) {
            if (config.start != undefined) {
                $(element).drop("start", config.start);
            }
            if (config.handler != undefined) {
                $(element).drop(config.handler, config.options);
            }
            if (config.end != undefined) {
                $(element).drop("end", config.end);
            }
        }
    }
};